import { render } from "./TheRGPDAcceptance.vue?vue&type=template&id=7a69f383&scoped=true&ts=true"
import script from "./TheRGPDAcceptance.vue?vue&type=script&lang=ts"
export * from "./TheRGPDAcceptance.vue?vue&type=script&lang=ts"

import "./TheRGPDAcceptance.vue?vue&type=style&index=0&id=7a69f383&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a69f383"]])

export default __exports__